import { CHECK_USERNAME } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

interface UsernameResponse {
    exists: boolean;
    valid: boolean | null;
    user_id: boolean | string;
}

export interface CheckUsernameState extends BaseAsyncReducerState {
    username: UsernameResponse;
}
// Define an initial state value for the app
const initialState: CheckUsernameState = {
    loading: false,
    error: false,
    username: {
        exists: false,
        valid: true,
        user_id: false
    }
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function checkUsernameReducer(state = initialState, action: AppAction): CheckUsernameState | Record<string, unknown> {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case CHECK_USERNAME.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                success: false,
            }
        case CHECK_USERNAME.SUCCESS:
            return {
                ...state,
                username: { ...payload },
                loading: false,
                error: false,

            }
        case CHECK_USERNAME.ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                data: payload,
            };
        case CHECK_USERNAME.RESET:
            return {
                ...state,
                ...initialState
            }
        default:
            return state
    }
}



export default checkUsernameReducer;